module.exports = __webpack_public_path__ + "static/assets/1a3b5ee6ad8a247afd05203de9104b44.png";